import React from "react";
import "./Header.css";

export default function Header() {
  return (
    <header className="mb-5">
      <h1 className="display-3">Simple Database of People</h1>
    </header>
  );
}
